import React from 'react';

const Sports = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_17206_46150)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.51949 16.4855C7.10016 20.0662 12.9056 20.0662 16.4862 16.4855C20.0669 12.9048 20.0669 7.09942 16.4862 3.51875C12.9056 -0.0619154 7.10016 -0.0619154 3.51949 3.51875C-0.0611827 7.09942 -0.0611832 12.9048 3.51949 16.4855ZM4.86141 16.0251C6.27258 17.2323 8.00768 17.863 9.75726 17.9169C10.0359 16.1292 10.8109 14.4031 12.0814 12.9621L10.0029 10.8836L4.86141 16.0251ZM3.97752 15.1408C2.77201 13.7303 2.14221 11.9967 2.0881 10.2486C3.87607 9.97003 5.60242 9.19507 7.04362 7.92436L9.11877 9.99951L3.97752 15.1408ZM10.887 9.99951L12.9656 12.0781C14.406 10.809 16.131 10.0347 17.9176 9.75616C17.8636 8.00671 17.233 6.27175 16.0258 4.86068L10.887 9.99951ZM15.1415 3.97679L10.0029 9.11541L7.92756 7.04011C9.19686 5.59952 9.9711 3.87424 10.2496 2.08737C11.9976 2.14152 13.7311 2.77133 15.1415 3.97679ZM11.0365 17.8534C11.3065 16.4102 11.9499 15.0238 12.9675 13.8482L15.1443 16.0251C13.9456 17.0506 12.5131 17.66 11.0365 17.8534ZM13.8517 12.9643L16.0282 15.1408C17.0524 13.9425 17.661 12.511 17.8541 11.0354C16.4121 11.3053 15.0267 11.948 13.8517 12.9643ZM3.97994 4.86068L6.15751 7.03825C4.98173 8.05596 3.59496 8.69951 2.15152 8.9694C2.34469 7.49252 2.95417 6.05968 3.97994 4.86068ZM8.97034 2.15076C7.49455 2.34375 6.06272 2.95243 4.86424 3.97679L7.04144 6.15399C8.05785 4.97879 8.70062 3.59306 8.97034 2.15076Z",
      fill: "#fff"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_17206_46150" }, /* @__PURE__ */ React.createElement("rect", { width: "20", height: "20", fill: "white" })))
);

export { Sports };
//# sourceMappingURL=Sports.js.map
